import { jsx as _jsx } from "react/jsx-runtime";
import React, { useReducer } from "react";
import { AdvancedFiltersTags } from "./Views/Tags";
import { AdvancedFiltersStates } from "./Views/States";
import { AdvancedFiltersView, AdvancedSelectedFilters } from "./Views/Summary";
function reducer(state, action) {
    switch(action.type){
        case "BACK_TO_VIEW":
            return {
                ...state,
                currentView: "view"
            };
        case "GO_TO_TAGS":
            return {
                ...state,
                currentView: "tags"
            };
        case "GO_TO_STATES":
            return {
                ...state,
                currentView: "states"
            };
        case "FILTER_TAGS":
            return {
                ...state,
                tags: action.tags,
                currentView: "view"
            };
        case "FILTER_STATES":
            return {
                ...state,
                states: action.states,
                currentView: "view"
            };
        case "CHANGE_SORT":
            return {
                ...state,
                sortBy: action.sortBy
            };
        case "CLEAR":
            return {
                ...state,
                states: [],
                tags: []
            };
    }
}
export function AdvancedFilters(param) {
    let { initialStates , initialTags , initialSortBy , onFilter , onCancel  } = param;
    const [{ currentView , states , tags , sortBy  }, dispatch] = useReducer(reducer, {
        currentView: "view",
        states: initialStates,
        tags: initialTags,
        sortBy: initialSortBy
    });
    const goToTags = ()=>{
        dispatch({
            type: "GO_TO_TAGS"
        });
    };
    const goToStates = ()=>{
        dispatch({
            type: "GO_TO_STATES"
        });
    };
    const onStatesFilters = (newStates)=>{
        dispatch({
            type: "FILTER_STATES",
            states: newStates
        });
    };
    const onTagsFilters = (newTags)=>{
        dispatch({
            type: "FILTER_TAGS",
            tags: newTags
        });
    };
    const onStateRemove = (id)=>{
        dispatch({
            type: "FILTER_STATES",
            states: states.filter((state)=>state !== id)
        });
    };
    const onTagRemove = (id)=>{
        dispatch({
            type: "FILTER_TAGS",
            tags: tags.filter((tag)=>tag !== id)
        });
    };
    const onSortChange = (sort)=>{
        dispatch({
            type: "CHANGE_SORT",
            sortBy: sort
        });
    };
    const onClear = ()=>{
        dispatch({
            type: "CLEAR"
        });
    };
    const back = ()=>{
        dispatch({
            type: "BACK_TO_VIEW"
        });
    };
    const handleOnFilter = ()=>{
        onFilter(tags, states, sortBy);
    };
    const handleOnCancel = ()=>{
        onCancel();
    };
    const renderView = ()=>{
        switch(currentView){
            case "view":
                return /*#__PURE__*/ _jsx(AdvancedFiltersView, {
                    onCancel: handleOnCancel,
                    onFilter: handleOnFilter,
                    onStatesClick: goToStates,
                    onTagsClick: goToTags,
                    onClear: onClear,
                    onSortChange: onSortChange,
                    sortBy: sortBy,
                    states: states,
                    tags: tags,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "max-h-[115px] overflow-y-auto",
                        children: /*#__PURE__*/ _jsx(AdvancedSelectedFilters, {
                            onStateRemove: onStateRemove,
                            onTagRemove: onTagRemove,
                            states: states,
                            tags: tags
                        })
                    })
                });
            case "tags":
                return /*#__PURE__*/ _jsx(AdvancedFiltersTags, {
                    onBack: back,
                    onFilter: onTagsFilters,
                    initialTags: tags
                });
            case "states":
                return /*#__PURE__*/ _jsx(AdvancedFiltersStates, {
                    onBack: back,
                    onFilter: onStatesFilters,
                    initialStates: states
                });
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-white rounded-xl w-full shadow h-[575px] p-4 border-[1px] border-neutral-200",
        children: renderView()
    });
}
